var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.panel.panel_widget_id === 9
        ? _c("listmap-component", { attrs: { permissions: _vm.permissions } })
        : _vm._e(),
      _vm.sbObj
        ? [
            _vm.panel.panel_widget_id === 16
              ? _c("projects", { attrs: { sbData: _vm.sbData } })
              : _vm._e(),
          ]
        : _vm._e(),
      _vm.sxObj
        ? [
            _vm.panel.panel_widget_id === 19
              ? _c("projects", { attrs: { sbData: _vm.sxObj, isSX: true } })
              : _vm._e(),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }